export const translations = {
  routeUpdateSuccessMessage: {
    pt: 'Rota atualizada com sucesso',
    en: 'Route updated successfully',
    es: 'Ruta actualizada con éxito',
    de: 'Route erfolgreich aktualisiert',
  },
  routeUpdateErrorMessage: {
    pt: 'Erro ao atualizar rota',
    en: 'Error updating route',
    es: 'Error al actualizar la ruta',
    de: 'Fehler beim Aktualisieren der Route',
  },
}